if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-cart') && document.querySelector('.cart-subtotal') != null){
  const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
  const apConfig = {
    priceSelector: '.cart-policies',
    locale: 'en_US',
    currency: 'USD',
    afterpayLogoColor: 'white',
    showUpperLimit: false,
    amount: cartTotal,
    minMaxThreshold: {
      min: 100,
      max: 100000,
    },
  };
  new presentAfterpay(apConfig).init();
  /* removing $ FP start 04-04-2025 */
/*  if(getCookie("remove_price_icon") == "true"){
    let afterPay = document.querySelector('.checkout-subtotal-container').querySelector('.afterpay-text1').textContent;
    if(afterPay.indexOf('$')){
      afterPay = afterPay.replace('$', '')
      document.querySelector('.checkout-subtotal-container').querySelector('.afterpay-text1').textContent = afterPay;
    }
  }*/
  /* removing $ FP end 04-04-2025 */
}
window.onload = function() {
  if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-product')){
    if(window.innerWidth > 768) {
      const ap = new presentAfterpay(apConfig).init();
    }
    apConfig.priceSelector = '.main-mobile-price-selector';
    new presentAfterpay(apConfig).init();
    var price = document.querySelector('product-form.sticky-content-container .price');
    var config = {childList: true, subtree: true };
    /* removing $ FP start 04-04-2025 */
    /*if(getCookie("remove_price_icon") == "true"){
      setTimeout(function(){
        let afterPay = document.querySelector('.js-product .product-form .main-price-selector+.afterpay-paragraph .afterpay-text1').textContent;
        if(afterPay.indexOf('$')){
          afterPay = afterPay.replace('$', '')
          document.querySelector('.js-product .product-form .main-price-selector+.afterpay-paragraph .afterpay-text1').textContent = afterPay;
        }
      }, 1500);
    }*/
    /* removing $ FP end 04-04-2025 */
  }  
  var intervalStampedInstagram = setInterval(function(){
    if(document.querySelector('body').classList.contains('template-product')){
      if(document.querySelector('.stamped-instagram-media-block-template') != null){
        if(document.querySelectorAll('.stamped-instagram-media-block').length < 2){
          document.querySelector('.hometitle.app_title').classList.add('hidden');
        }else{
          document.querySelector('.hometitle.app_title').classList.remove('hidden');
        }
        clearInterval(intervalStampedInstagram);
      }
    }
  },3000);

}
$(document).ready(function(){
  const customSlider = document.querySelector('.custom-slider-block');
  if(customSlider != null){
    const customSliderConf = document.querySelector('.slider-config').textContent;
    const configuration = JSON.parse(customSliderConf);
    if($('.custom-slider-block').hasClass('slick-slider')){
      $('.custom-slider-block').slick(configuration);
    }else{
      $('.custom-slider-block').owlCarousel(configuration);
    }
  }

    /* lux rave slider on mobile AP 19-03-2025 */
  if ($(window).width() < 480) {
    $('.meet-greet-rows').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        dots: false,        
        centerPadding: '80px',
        infinite: true,
        
     });
  }
  /* lux rave slider on mobile AP 19-03-2025 */
  
});